import { ProgramPreview } from '../../../api/newsfeed.types'
import { ProgramsAllAction } from './programs.all.types'

export const programsAllRequestAction = (): ProgramsAllAction => ({ type: 'PROGRAMS_ALL_REQUEST' })
export const programsAllSuccessAction = (programs: ProgramPreview[]): ProgramsAllAction => ({ type: 'PROGRAMS_ALL_SUCCESS', params: programs })
export const programsAllFailureAction = (error?: any): ProgramsAllAction => ({ type: 'PROGRAMS_ALL_FAILURE', params: error })